import { render, staticRenderFns } from "./cancel.vue?vue&type=template&id=2b383518&"
import script from "./cancel.vue?vue&type=script&lang=js&"
export * from "./cancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b383518')) {
      api.createRecord('2b383518', component.options)
    } else {
      api.reload('2b383518', component.options)
    }
    module.hot.accept("./cancel.vue?vue&type=template&id=2b383518&", function () {
      api.rerender('2b383518', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/components/quota/cancel.vue"
export default component.exports